// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__C-2R1","title":"ClientReferral_title__2PpFe","itemText":"ClientReferral_itemText__16-VC"};